import styled from "styled-components";

/** Catalog grid cell — node cards are 120×120 per Figma. */
export const TileWrap = styled.div`
  display: flex;
  flex-shrink: 0;
  cursor: pointer;
`;
